// @flow

import { type Theme, getSize, getWeight } from "views/resources/theme";
import React from "react";
import styled, { type StyledComponent } from "styled-components";
import type { Node } from "react";

interface Props {
	children: Node;
	solid: boolean;
	onClick: () => void;
	type: string;
}

const AtrasButton = ({ children, solid, type, onClick }: Props) => (
	<Button solid={solid} type={type} onClick={onClick}>
		{children}
	</Button>
);

type ButtonProps = {|
	solid: boolean,
	type: string,
	children: Node,
	onClick(): void,
|};

type SetBackgroundArgs = {
	solid: boolean,
	theme: Theme,
};

const setBackground = ({ solid, theme }: SetBackgroundArgs) => {
	if (solid) {
		return `
      background-color: white;
      color: ${theme.colors.secondary_light};
    `;
	} else {
		return `
      border: 1px solid white;
      color: white;
    `;
	}
};

const Button: StyledComponent<
	ButtonProps,
	Theme,
	HTMLButtonElement
> = styled.button`
	text-align: center;
	padding: ${getSize("sm")};
	font-weight: ${getWeight("medium")};
	font-size: ${getSize("m")};
	border-radius: ${getSize("l")};
	cursor: pointer;
	margin-bottom: ${getSize("l")};
	border: none;
	outline: none;
	background: none;
	font-family: Montserrat;
	width: 100%;
	${setBackground}
`;

export default AtrasButton;
